



















































































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { Cliente } from "@/typings/store/plugins/easyFirestore/clientes";
import { required, email } from "vuelidate/lib/validators";
import { DataFormularioCliente } from "@/typings/components/clientes/formulario";
// Acepta "77.460.718-8" y "77460718-8": los clientes importados traen puntos.
import { rutChileno } from "@/helpers/rut";

@Component({
  validations: {
    form: {
      codigo: { required },
      nombre: { required },
      rut: { required, rutChileno },
      correo: { email }, // Se añade validación de email
    },
  },
})
export default class FormularioCliente extends Vue {
  @Prop() readonly cliente!: Cliente | null;
  @Prop() readonly cargando!: boolean;

  // MEJORA: Se agrupan los campos en un objeto `form` para mayor orden.
  form = {
    id: null as string | null,
    codigo: "",
    nombre: "",
    rut: "",
    giro: "",
    telefono: "",
    direccion: "",
    correo: "",
    comuna: "",
    ciudad: "",
    codigoSoftland: "",
    codigoActividad: "",
  };
  $toast!: { error(message: string): void };

  created(): void {
    const cliente = this.cliente;
    if (!cliente) return;

    this.form.id = cliente.id ?? null;
    this.form.codigo = cliente.codigo ?? "";
    this.form.nombre = cliente.nombre;
    this.form.rut = cliente.rut ?? "";
    this.form.giro = cliente.giro ?? "";
    this.form.telefono = cliente.telefono ?? "";
    this.form.direccion = cliente.direccion ?? "";
    this.form.correo = cliente.correo ?? "";
    this.form.comuna = cliente.comuna ?? "";
    this.form.ciudad = cliente.ciudad ?? "";
    this.form.codigoSoftland = cliente.codigoSoftland ?? "";
    this.form.codigoActividad = cliente.codigoActividad ?? "";
  }

  get titulo(): string {
    return this.cliente ? "Editar Cliente" : "Nuevo Cliente";
  }

  // MEJORA: Un solo método para manejar todos los errores.
  getErrors(fieldName: string): string[] {
    const errors: string[] = [];
    const field = this.$v.form?.[fieldName];
    if (!field || !field.$dirty) return errors;

    if (field.required === false) errors.push("Este campo es obligatorio.");
    if (field.email === false) errors.push("Debe ser un correo válido.");
    if (field.rutChileno === false) errors.push("El RUT no es válido.");

    return errors;
  }

  @Emit("close")
  onClose(): null {
    return null;
  }

  // No necesitas onCerrarDialogo si onClose ya emite "close"
  // @Emit("cerrar-dialogo")
  // onCerrarDialogo(): void { return; }

  @Emit("click-guardar")
  onClickGuardar(data: DataFormularioCliente): DataFormularioCliente {
    return data;
  }

  guardar(): void {
    this.$v.$touch();
    if (this.$v.$invalid) {
      this.$toast.error("Por favor, corrige los errores en el formulario.");
      return;
    }

    const doc: Cliente = {
      codigo: this.form.codigo,
      nombre: this.form.nombre,
      rut: this.form.rut,
      giro: this.form.giro,
      telefono: this.form.telefono,
      direccion: this.form.direccion,
      correo: this.form.correo,
      // Se conservan: el formulario no los edita (el importador guarda ahí el nombre del local).
      rubro: this.cliente?.rubro ?? "",
      nombre_comercial: this.cliente?.nombre_comercial ?? "",
      comuna: this.form.comuna.trim(),
      ciudad: this.form.ciudad.trim(),
      codigoSoftland: this.form.codigoSoftland.trim(),
      codigoActividad: this.form.codigoActividad.trim(),
    };
    if (this.form.id) {
      doc.id = this.form.id;
    }

    this.onClickGuardar({ doc });
  }
}
